(function ($) {

    $(document).ready(function () {

        var block = $('.co-chairs .info-block');

        if ($(block).length > 3) {
            $(block).addClass("two-columns");
        } else {
            $(block).removeClass("two-columns");
        }
    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/co-chairs-flex-count.es6